<template>
  <kst-print-table :data="items">
    <b-table-column 
      v-slot="{ column, row }"
      field="DispatchID"
      cell-class="kst-report-dailyreport-dispatch"
      :label="Catalog.DispatchID.Label"
    >
      <kst-value :field="column.field" :data="row" :catalog="Catalog"/>
    </b-table-column>

    <b-table-column centered
      v-slot="{ column, row }"
      field="QtyBeginning"
      cell-class="kst-report-dailyreport-qty"
      :label="Catalog.QtyBeginning.Label"
    >
      <kst-value :field="column.field" :data="row" :catalog="Catalog"/>
    </b-table-column>

    <b-table-column centered
      v-slot="{ column, row }"
      field="QtyReceive"
      cell-class="kst-report-dailyreport-qty"
      :label="Catalog.QtyReceive.Label"
    >
      <kst-value :field="column.field" :data="row" :catalog="Catalog"/>
    </b-table-column>

    <b-table-column centered
      v-slot="{ column, row }"
      field="QtyTrf"
      cell-class="kst-report-dailyreport-qty"
      :label="Catalog.QtyTrf.Label"
    >
      <kst-value :field="column.field" :data="row" :catalog="Catalog"/>
    </b-table-column>

    <b-table-column centered
      v-slot="{ column, row }"
      field="QtyAdj"
      cell-class="kst-report-dailyreport-qty"
      :label="Catalog.QtyAdj.Label"
    >
      <kst-value :field="column.field" :data="row" :catalog="Catalog"/>
    </b-table-column>

    <b-table-column centered
      v-slot="{ column, row }"
      field="QtyReduction"
      cell-class="kst-report-dailyreport-qty"
      :label="Catalog.QtyReduction.Label"
    >
      <kst-value :field="column.field" :data="row" :catalog="Catalog"/>
    </b-table-column>

    <b-table-column centered
      v-slot="{ column, row }"
      field="QtySales"
      cell-class="kst-report-dailyreport-qty"
      :label="Catalog.QtySales.Label"
    >
      <kst-value :field="column.field" :data="row" :catalog="Catalog"/>
    </b-table-column>

    <b-table-column centered
      v-slot="{ column, row }"
      field="QtyLast"
      cell-class="kst-report-dailyreport-qty"
      :label="Catalog.QtyLast.Label"
    >
      <kst-value :field="column.field" :data="row" :catalog="Catalog"/>
    </b-table-column>

    <b-table-column centered
      v-slot="{ column, row }"
      field="QtyClosing"
      cell-class="kst-report-dailyreport-qty"
      :label="Catalog.QtyClosing.Label"
    >
      <kst-value :field="column.field" :data="row" :catalog="Catalog"/>
    </b-table-column>
  </kst-print-table>
</template>

<script>
import Catalog from "../DailyReportCatalog.js";
import Model from "../DailyReportModel.js";

export default {
  props: {
    items: Array
  },
  data: () => ({
    Catalog: Catalog,
    Model: Model
  })
}
</script>